import { Property } from '@/types';
import clsx from 'clsx';
import NumberFormat from '@/components/ui/react-number-format';
import { Progress } from './progress';

interface PriceComparisionLineItemProps {
  value: number;
  comparisionResult: number;
  danger?: boolean;
  masterProperty?: Property;
  property: Property;
  field: string;
}

export const PriceComparisionLineItem: React.FC<
  PriceComparisionLineItemProps
> = (props) => {
  let diff = <></>;

  if (
    props.masterProperty &&
    props.masterProperty.propertyNumber !== props.property.propertyNumber
  ) {
    const diffAmount = Math.round(
      props.property[props.field] - props.masterProperty[props.field]
    );

    diff = (
      <>
        {' '}
        <span className={diffAmount > 0 ? 'text-red-500' : 'text-green-500'}>
          (
          {
            <NumberFormat
              value={diffAmount || 0}
              displayType={'text'}
              thousandSeparator={true}
              prefix={'$'}
              className={clsx('text-bold')}
            />
          }
          )
        </span>
      </>
    );
  }

  return (
    <div className="relative">
      <Progress value={props.comparisionResult} danger={props.danger} />
      <div className="px-2 py-2 text-center">&nbsp;</div>
      <div className="px-2 py-2 text-center absolute inset-0 p-1">
        <NumberFormat
          value={props.value || 0}
          displayType={'text'}
          thousandSeparator={true}
          prefix={'$'}
        />
        {diff}
      </div>
    </div>
  );
};
